export default __webpack_public_path__ + "static/media/avatar.df87bd57.jpg";